import type { IconSvgObject } from './types';

const Tick03Icon: IconSvgObject = [
  ["path", { d: "M2.70711 13.2929L4.29289 11.7071C4.68342 11.3166 5.31658 11.3166 5.70711 11.7071L8.5 14.5L17.7945 4.27601C18.1786 3.85354 18.8378 3.83785 19.2416 4.24158L21.2929 6.29289C21.6834 6.68342 21.6834 7.31658 21.2929 7.70711L9.20711 19.7929C8.81658 20.1834 8.18342 20.1834 7.79289 19.7929L2.70711 14.7071C2.31658 14.3166 2.31658 13.6834 2.70711 13.2929Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Tick03Icon;
